module.exports = global["ReactDOM"] = require("-!./index.js");


//////////////////
// WEBPACK FOOTER
// ./~/react-dom/index.js
// module id = 376
// module chunks = 0